export interface SEOData {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, any>;
}

export const seoData: Record<string, SEOData> = {
  '/': {
    title: 'مينا أطلس | تمويل الصفقات وإدارة الاستثمار',
    description: 'شركة مينا أطلس للتجارة - شركة استثمارية خاصة متخصصة في تمويل الصفقات التجارية الدولية وإدارة الاستثمار في المملكة العربية السعودية. نقدم حلول تمويل احترافية للمستثمرين المؤسسيين وذوي الملاءة المالية العالية مع إدارة مخاطر محسوبة وعوائد مدروسة.',
    keywords: 'تمويل الصفقات,إدارة الاستثمار,التجارة الدولية,استثمار خاص,السعودية,مينا أطلس,جدة,استثمار تجاري,عوائد استثمارية',
    canonical: '/',
    ogTitle: 'مينا أطلس | تمويل الصفقات وإدارة الاستثمار',
    ogDescription: 'شركة مينا أطلس للتجارة - شركة استثمارية خاصة متخصصة في تمويل الصفقات التجارية الدولية وإدارة الاستثمار في المملكة العربية السعودية.',
    ogType: 'website',
    ogImage: 'https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/41a4723fde790fea41e043067925b21a.png',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'FinancialService',
      name: 'مينا أطلس للتجارة',
      description: 'شركة استثمارية خاصة متخصصة في تمويل الصفقات التجارية الدولية وإدارتها',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'جدة',
        addressRegion: 'مكة المكرمة',
        addressCountry: 'SA',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '21.4858',
        longitude: '39.1925',
      },
      email: 'info@menaatlas.com',
      telephone: '+966553176836',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
      areaServed: {
        '@type': 'Country',
        name: 'المملكة العربية السعودية',
      },
      serviceType: ['تمويل الصفقات', 'إدارة الاستثمار', 'التجارة الدولية'],
      image: 'https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/41a4723fde790fea41e043067925b21a.png',
    },
  },
};

export const getPageSEO = (path: string): SEOData | null => {
  return seoData[path] || null;
};
